import apiClient from './api'

export const checkoutService = {
  /**
   * Recupera il riepilogo del checkout
   * Endpoint: GET /api/checkout/summary
   */
  async getCheckoutSummary() {
    try {
      const response = await apiClient.get('/checkout/summary')
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore nel recupero del riepilogo:', error)
      throw error
    }
  },

  /**
   * Crea una bozza d'ordine a partire dal carrello
   * @param {Object} draftData - { shippingAddressId, billingAddressId, customerNote, isGuest, customerEmail, shippingAddress, billingAddress, cartItems }
   * @param {string} recaptchaToken 
   */
  async createDraftOrder(draftData, recaptchaToken = null) {
    try {
      const payload = { ...draftData, recaptchaToken: recaptchaToken ?? '' }
      const response = await apiClient.post('/salesorders/draft', payload)
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore nella creazione della bozza ordine:', error)
      throw error
    }
  },

  /**
   * Recupera dettaglio ordine guest per tracciamento
   * @param {string} trackingToken
   */
  async getGuestOrder(trackingToken) {
    try {
      const response = await apiClient.get(`/salesorders/guest/${trackingToken}`)
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore recupero ordine guest:', error)
      throw error
    }
  },

  /**
   * Inizializza il pagamento su Stripe
   * @param {number} orderId 
   * @param {string} guestTrackingToken 
   * @param {string} recaptchaToken 
   */
  async initializePayment(orderId, guestTrackingToken = null, recaptchaToken = null) {
    try {
      const payload = { orderId, recaptchaToken: recaptchaToken ?? '' }
      if (guestTrackingToken) {
        payload.guestTrackingToken = guestTrackingToken
      }
      const response = await apiClient.post('/payments/initialize', payload)
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore inizializzazione pagamento:', error)
      throw error
    }
  },

  async getSessionStatus(sessionId) {
    try {
      const response = await apiClient.get(`/payments/session/${sessionId}/status`)
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore recupero stato sessione:', error)
      throw error
    }
  },

  async getOrderStatus(orderId, sessionId = null, guestTrackingToken = null) {
    try {
      const params = {}
      if (sessionId) params.sessionId = sessionId
      if (guestTrackingToken) params.guestTrackingToken = guestTrackingToken
      const response = await apiClient.get(`/salesorders/${orderId}/status`, { params })
      return response.data
    } catch (error) {
      console.error('[CheckoutService] Errore recupero stato ordine:', error)
      throw error
    }
  }
}

export default checkoutService
